function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M271 542c149.7 0 271-121.3 271-271S420.7 0 271 0 0 121.3 0 271s121.3 271 271 271z",
  fill: "#f89022"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M478.3 333.7h-40l-28.4-24.3-28.3 24.2h-33.8l-16.2-19.7h-55.8l14.1-17.4h27.4L296.4 271l-72.9 88.8h-33.8l21.1-25.8h-35.2l-19-53.4-18.9 53h-35.9l-30-83.2h27.4l20.2 56.7 20.1-56.4h33.9l20.1 56.3 20.1-56.3H241l-30.3 83.4 6.7-8.2 61.9-75.3h34l51.5 62.8 24.8-21.3-78.3-67.7h40.2l126.8 109.3zm-39.8-50.4l-18.9-16.2 18.8-16.1h38.1l-38 32.3z",
  fill: "#fff"
});

function SvgWax(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 542 542",
    width: 24,
    height: 25
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "e2035ceb4657d4708978283bd8da5ac9.svg";
export { SvgWax as ReactComponent };